import SettingsMessage from './SettingsMessage/SettingsMessage'
import SettingsSelector from './SettingsSelector/SettingsSelector'
import * as Styles from './styles'

const SettingsSection = ({ type, onChange, title, message, disabled }) => {
  return (
    <Styles.Container type={type}>
      <SettingsMessage type={type} title={title} message={message} />
      <SettingsSelector value={type} onChange={onChange} disabled={disabled} />
    </Styles.Container>
  )
}

export default SettingsSection
